export const replaceItem = <T>(items: T[], newItem: T, index: number) => [
  ...items.slice(0, index),
  newItem,
  ...items.slice(index + 1),
];
